import { createFileRoute } from "@tanstack/react-router";
import OrganizationSettings from "src/pages/OrganizationSettings/OrganizationSettings";

export const Route = createFileRoute("/_dashboard/_authenticated/organization")({
	component: () => <OrganizationSettings />
});
